import { app } from '../app';

app.factory('GoogleSharedService', GoogleSharedService);

/** @ngInject */
function GoogleSharedService($resource) {
    
    var getGoogleAuthUrl = $resource('app/rest/googleauth/requesturl', {
    }, {});
    
    
    var getEmailStatus = $resource('app/rest/googleconfig/checkemailstatus', {
    }, {});
    
    var getGoogleAppsInfo = $resource('app/rest/googleconfig/googleappsinfo', {
    }, {});
    
    var saveGoogleApplication = $resource('app/rest/googleconfig/savegoogleapplication', {
    }, {});
    
    var updateGoogleApplicationWithDomain = $resource('app/rest/googleconfig/updategoogleapplication', {
    }, {}); 
    
    var updateUserEmailOwner = $resource('app/rest/googleconfig/updatemailowner', {
    }, {}); 
    
    var createUserEmail = $resource('app/rest/googleconfig/createuseremail', {
    }, {});
    
    var changeUserEmailOwnerNoDomain = $resource('app/rest/googleconfig/updateuseremailnodomain', {
    }, {});
    
    var updateCompanyWithDomain = $resource('app/rest/googleconfig/updatecompanywithdomain', {
    }, {});
    
    var createCompanyWithDomain = $resource('app/rest/googleconfig/createcompanywithdomain', {
    }, {});
    
    var getGoogleEndUserAuthUrl = $resource('app/rest/googleauth/requesturlenduser', {
    }, {});
    
    
    return {
        getGoogleAuthUrl: getGoogleAuthUrl,
        getEmailStatus: getEmailStatus,
        getGoogleAppsInfo: getGoogleAppsInfo,
        saveGoogleApplication:saveGoogleApplication,
        updateGoogleApplicationWithDomain:updateGoogleApplicationWithDomain,
        updateUserEmailOwner:updateUserEmailOwner,
        createUserEmail:createUserEmail,
        changeUserEmailOwnerNoDomain:changeUserEmailOwnerNoDomain,
        updateCompanyWithDomain:updateCompanyWithDomain,
        createCompanyWithDomain:createCompanyWithDomain,
        getGoogleEndUserAuthUrl:getGoogleEndUserAuthUrl
    }
}



// WEBPACK FOOTER //
// ./src/portal/services/google-shared.service.js